import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Step, StepLabel, Stepper, CircularProgress, Divider } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import SaveIcon from '@material-ui/icons/Save'

import { Page, Header, CustomButton } from 'components'
import { FormDocumento } from './components/FormDocumento'
import { ResultadoNecropapiloscopico } from './components/ResultadoNecropapiloscopico'

import { useExameNecropapiloscopico } from './hooks/useExameNecropapiloscopico'
import { useStyles } from './ExameNecropapiloscopico.styles'

export const ExameNecropapiloscopico = (props) => {
  const { route } = props
  const classes = useStyles()

  const {
    activeStep,
    exameNecropapiloscopico,
    disableBotaoAvancar,
    processando,
    processandoFinalizacaoExame,
    form,
    setDisableBotaoAvancar,
    handleVoltar,
    handleEtapaAnterior,
    handleProximaEtapa,
    idExameRealizado,
  } = useExameNecropapiloscopico()

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />

      {processando || !exameNecropapiloscopico ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <>
          <Stepper alternativeLabel activeStep={activeStep} className={classes.stepper}>
            <Step key="Dados da análise">
              <StepLabel>Dados da análise realizada</StepLabel>
            </Step>
            <Step key="Dados confrontados">
              <StepLabel>Dados retornados do sistema ou documento confrontado</StepLabel>
            </Step>
          </Stepper>

          <div className={classes.stepContainer}>
            {activeStep === 0 && (
              <ResultadoNecropapiloscopico
                idExameSolicitado={exameNecropapiloscopico.exReal.exSol.id}
                idExameRealizado={exameNecropapiloscopico.id}
                setDisableBotaoAvancar={setDisableBotaoAvancar}
              />
            )}
            {activeStep === 1 && (
              <FormDocumento
                exame={exameNecropapiloscopico}
                form={form}
                idExameSolicitado={exameNecropapiloscopico.exReal.exSol.id}
                idExameRealizado={idExameRealizado}
                carregando={processando}
                setDisableBotaoAvancar={setDisableBotaoAvancar}
              />
            )}
          </div>

          <Divider className={classes.divider} />

          <Grid container justifyContent="space-between" spacing={1} className={classes.navigationContainer}>
            <Grid item>
              {activeStep === 0 ? (
                <CustomButton
                  variant="outlined"
                  onClick={handleVoltar}
                  startIcon={<ArrowBackIcon />}
                >
                  Voltar
                </CustomButton>
              ) : (
                <CustomButton
                  variant="outlined"
                  onClick={handleEtapaAnterior}
                  startIcon={<NavigateBeforeIcon />}
                >
                  Etapa Anterior
                </CustomButton>
              )}
            </Grid>
            <Grid item>
              <CustomButton
                variant="contained"
                color="primary"
                onClick={handleProximaEtapa}
                disabled={disableBotaoAvancar || processandoFinalizacaoExame}
                isLoading={processandoFinalizacaoExame}
                startIcon={activeStep === 1 ? <SaveIcon /> : <NavigateNextIcon />}
              >
                {activeStep === 1 ? 'Finalizar formulário' : 'Próxima Etapa'}
              </CustomButton>
            </Grid>
          </Grid>
        </>
      )}
    </Page>
  )
}

ExameNecropapiloscopico.propTypes = {
  route: PropTypes.shape({
    titulo: PropTypes.string.isRequired,
    secao: PropTypes.string.isRequired,
  }).isRequired,
}
